import { render, staticRenderFns } from "./CopyrightAssignmentTransferFormFilesEscalated.vue?vue&type=template&id=13a3b215&scoped=true&"
import script from "./CopyrightAssignmentTransferFormFilesEscalated.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferFormFilesEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferFormFilesEscalated.vue?vue&type=style&index=0&id=13a3b215&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a3b215",
  null
  
)

export default component.exports